export { default as TiposPagoListar } from './Listar'
export { default as TipoPagoCrear } from './Crear'
